







import { Component, Vue } from 'vue-property-decorator'

import ContractData from '@/components/layouts/Contracts/ContractData.vue'
import Breadcrumbs, { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'

@Component({
  components: {
    ContractData,
    Breadcrumbs,
  },
})
class ContractInfoView extends Vue {
  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Мои услуги',
      disabled: false,
      to: { name: 'main/services' },
    },
    {
      text: 'Договоры',
      disabled: false,
      to: { name: 'services/contracts' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]
}

export default ContractInfoView
